import { render, staticRenderFns } from "./GreenPartCompensation.vue?vue&type=template&id=48c0e162"
import script from "./GreenPartCompensation.vue?vue&type=script&lang=ts"
export * from "./GreenPartCompensation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports